module.exports = __webpack_public_path__ + "img/engineer_share.9bf78a98.jpg";